<div class="header">
  <h1 class="title">What data would you like to use?</h1>
  <div class="report-tiles">
    <mode-data-tile
      class="tile"
      data-test="dataset-tile-selector"
      title="Dataset"
      caption="Explore curated data from your organization"
      (clicked)="selectDataset()"
    >
      <div class="tile-icon" style="background-color: var(--ds-purple-400); color: var(--ds-white)">
        <capra-icon icon="icon-dataset"></capra-icon>
      </div>
    </mode-data-tile>
    <mode-data-tile
      *ngIf="queryMetricsEnabled$ | async"
      class="tile"
      data-test="dbt-tile-selector"
      title="Metric"
      caption="Answer questions with predefined business metrics"
      badgeText="EXPERIMENTAL"
      (clicked)="selectMetric()"
    >
      <div class="tile-icon">
        <capra-icon icon="illo-dbt-logo" height="20px" width="53px"></capra-icon>
      </div>
    </mode-data-tile>
    <mode-data-tile
      class="tile"
      data-test="sql-tile-selector"
      title="SQL Query"
      caption="Query your data directly"
      (clicked)="navigateToLegacyNewReport()"
    >
      <div class="tile-icon" style="background-color: var(--ds-gray-1100); color: var(--ds-white)">
        <capra-icon icon="icon-sql"></capra-icon>
      </div>
    </mode-data-tile>
  </div>
</div>
